import { range } from "@s-libs/micro-dash";

import { GRADE_LEVELS } from "@/admin/AdminConsoleContentSettingsPage/AdminConsoleContentSettingsPage.constants";
// The argument grade-groups is an array comprised of object-literals that each
// represent a grade-group that is created for the Content Settings feature in which
// users create grade-groups to apply content-restrictions against. These groups
// are returned by Content-Settings API endpoints and thus are each expected
// to have a `grade_minimum` and `grade_maximum` property.
export const getListOfGradesInContentSettingsGroups = (gradeGroups = []) => {
  const batchesOfSingleGradeListings = gradeGroups.map((group) => {
    const minimumGradeValue = GRADE_LEVELS.find(
      (grade) => grade.value === group.grade_minimum,
    ).value;
    const maximumGradeValue = GRADE_LEVELS.find(
      (grade) => grade.value === group.grade_maximum,
    ).value;
    const rangeStep = range(minimumGradeValue, maximumGradeValue + 1, 1).join(
      ", ",
    );
    return minimumGradeValue === maximumGradeValue
      ? minimumGradeValue
      : `${rangeStep}`;
  });

  const flatListingOfGrades = [...new Set(batchesOfSingleGradeListings.flat())]; // to rid it of duplicates and to flatten it.
  return flatListingOfGrades.join(", "); // create a single string and replace zero with "K"
};

export default getListOfGradesInContentSettingsGroups;
